import { render } from "./ParentRouteLayout.vue?vue&type=template&id=d21e9cdc"
import script from "./ParentRouteLayout.vue?vue&type=script&lang=js"
export * from "./ParentRouteLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__